// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_t6-5";
export var filledCircle = "_t6-4";
export var historyEntry = "_t6-3";
export var messageSideLeft = "_t6-1";
export var messageSideRight = "_t6-2";
export var orderTrackingCarouselWrapper = "_t6-6";
export var orderTrackingInfoContainer = "_t6-0";